import angular from "angular";
import { TimeEntryDashboardModule } from "./dashboard/time-entry-dashboard.module";
import { TimeEntryEditModule } from "./edit/time-entry-edit-module";

import { ListTimeEntriesContainerComponent } from "./list-time-entries/list-time-entries-container.component";
import { ListTimeCardsContainerComponent } from "./list-time-cards/list-time-cards-container.component";
import { TimeGapDecorator } from './time-gap-decorator.service';
import { TimeEntryRoutingModule } from "./time-entry-routing.module";
import { ListTimeEntriesExceptionsContainerComponent } from "./list-exceptions/list-time-entries-exceptions-container.component";
import { ListTimeEntriesExceptionsComponent } from "./list-exceptions/list-time-entries-exceptions.component";

export const TimeEntryModule = angular
    .module("apex.mainApp.timeEntry", [
        TimeEntryDashboardModule,
        TimeEntryEditModule,
        TimeEntryRoutingModule
    ])
    .component("apexListTimeEntriesContainer", ListTimeEntriesContainerComponent)
    .component("apexListTimeCardsContainer", ListTimeCardsContainerComponent)
    .component("apexListTimeEntriesExceptionsContainer", ListTimeEntriesExceptionsContainerComponent)
    .component("apexListTimeEntriesExceptions", ListTimeEntriesExceptionsComponent)
    .service("timeGapDecorator", TimeGapDecorator)
    .name;
